import { getActionAuthorization } from '../commons/utils';

const PRODUCT_ACTIONS_RESOURCE = {
  DOWNLOAD_TEMPLATE: 'products:batch:template',
  IMPORT: 'products:batch:import',
  DOWNLOAD_BATCH_UPDATE_TEMPLATE: 'products:batch:update:template',
  IMPORT_BATCH_UPDATE: 'products:batch:update:import',
};

export const canDownloadProductTemplate = (actions) =>
  getActionAuthorization(actions, PRODUCT_ACTIONS_RESOURCE.DOWNLOAD_TEMPLATE);

export const canImportProduct = (actions) =>
  getActionAuthorization(actions, PRODUCT_ACTIONS_RESOURCE.IMPORT);

export const canDownloadBatchUpdateProductTemplate = (actions) =>
  getActionAuthorization(actions, PRODUCT_ACTIONS_RESOURCE.DOWNLOAD_BATCH_UPDATE_TEMPLATE);

export const canImportBatchUpdateProduct = (actions) =>
  getActionAuthorization(actions, PRODUCT_ACTIONS_RESOURCE.IMPORT_BATCH_UPDATE);
